import React from "react";
import './CategoryPage.css';

import { Heading, PageTitle, Category } from "../../../components";
import { cars } from "../../../constants";
import { getPopularCarCategories } from "../../../utils";



const CategoryPage = () => {

  // Get the Car Categories
  const categories = getPopularCarCategories(cars);

  return (

    <>

      {/* Page title */}
      <PageTitle title={'Car Categories'} page={'Car Categories'} />

      <section className="categories">

        {/* Section Heading */}
        <Heading title={'Explore Our Rental Cars'} span={'Car Categories'} />

        {/* Category Items */}
        <div className="box-container">

          {/* Map over the categories array to render each category */}
          {categories.map(({ index, category, count, image }) => (
            <Category
              key={index}
              index={index}
              category={category}
              count={count}
              image={image}
            />
          ))}

        </div>

      </section>

    </>
  );
};

export default CategoryPage;